module.exports = __webpack_public_path__ + "img/apple-btn.2b1b1492.png";